export const CHECK_IN_TIME_END_FLEXIBLE = 'FLEXIBLE';
